const mergeObject = require('hobbit-base/modules/plugins/mergeObject');
const engineBaseConfig = require('hobbit-engine-base/modules/config');
const appName = require('../package.json').name;

module.exports = mergeObject(engineBaseConfig, {
  runtime: process.env.VUE_APP_RUNTIME,
  site: {
    // publicPath: `https://s.vipkidstatic.com/fe-static/${appName}/prod/${process.env.VUE_APP_DRONE || 'default'}/`,
    publicPath: 'https://s.vipkidstatic.com/fe-static/wombat/html/prod/',
    noLangPath: true,
    supportLangs: [
      {
        lang: 'en-us',
        text: 'English',
        pcAppLangCode: 0,
      },
    ],
  },
  log: false,
  routes: {
    home: {
      index: 1,
      path: '/',
      view: '/home/home.vue',
    },
    classroom: {
      index: 1,
      path: '/classroom/',
      view: '/classroom/classroom.vue',
    },
    // 教材页
    teachmaterials: {
      index: 2,
      path: '/course/materials/',
      view: '/teachmaterials/teachmaterials.vue',
    },
    fm: {
      index: 3,
      path: '/fm/',
      view: '/fm/fm.vue',
    },
    // app 调用模板前置页
    coursemodel: {
      index: 99,
      path: '/course/model/',
      view: '/coursemodel/coursemodel.vue',
    },
    // 用户相关
    signin: {
      index: 4,
      path: '/user/signin/',
      view: '/ucenter/signin/signin.vue',
    },
    // 报告页
    report: {
      index: 5,
      path: '/user/report/',
      view: '/ucenter/report/report.vue',
    },
  },
  abtest: {},
  // 业务自定义配置信息
  custom: {},
});
